export const album = [
  {
    path: "/album-v2",
    name: "AlbumModule",
    component: () => import("@/modules/album/Album.vue"),
  },
  {
    path: "/album-v2/detail/:id",
    name: "AlbumModuleDetail",
    props: true,
    component: () => import("@/modules/album/AlbumDetail.vue"),
  },
  {
    path: "/album-v2/add",
    name: "AlbumModuleAdd",
    props: true,
    component: () => import("@/modules/album/AddAlbum.vue"),
  },
];
